import React from 'react'
import {Icon} from 'semantic-ui-react'
import {resume} from './resume'

const Socials = ({size}) => {
    return (
        <div className='socials'>
            <a href={resume.social.facebook} target="_blank">
                <Icon name='facebook' circular color="black" size={size}/>
            </a>
            <a href={resume.social.github} target="_blank">
                <Icon name='github' circular color="black" size={size}/>
            </a>
            <a href={resume.social.linkedin} target="_blank">
                <Icon name='linkedin' circular color="black" size={size}/>
            </a>
            <a href={resume.social.mail} target="_blank">
                <Icon name='mail' circular color="black" size={size}/>
            </a>
            <a href={resume.social.resume} target="_blank">
                <Icon name='address book outline' circular color="black" size={size}/>
            </a>
        </div>
    );
};

export default Socials


// WEBPACK FOOTER //
// ./src/Infos/socials.js